module.exports = __webpack_public_path__ + "img/thumb-005-22.73459ee1.png";